
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.079 5.59a2.711 2.711 0 111.185 2.241.498.498 0 01-.123.203l-2.69 2.69a.63.63 0 01-.022.02c.19.292.326.623.392.979h3.416a.5.5 0 01.127.016 1.606 1.606 0 110 .967.5.5 0 01-.127.017H13.82c-.069.37-.213.715-.417 1.016a.518.518 0 01.048.042l3.764 3.764.013.014a2.158 2.158 0 11-.714.7.383.383 0 01-.006-.007l-3.764-3.764a.495.495 0 01-.038-.041 2.7 2.7 0 01-1.55.487c-.546 0-1.053-.161-1.478-.438l-2.68 2.68a.504.504 0 01-.054.047 2.158 2.158 0 11-.682-.723.5.5 0 01.028-.03l2.664-2.664a2.698 2.698 0 01-.51-1.583c0-.576.18-1.11.486-1.549L6.374 8.118a1.605 1.605 0 11.697-.717l2.573 2.572a2.698 2.698 0 011.512-.461c.591 0 1.138.189 1.583.51a.127.127 0 01.005-.006l2.69-2.689a.498.498 0 01.182-.116 2.699 2.699 0 01-.537-1.621zm2.71-1.711a1.711 1.711 0 100 3.422 1.711 1.711 0 000-3.422zM5.63 6.089a.605.605 0 100 1.212.605.605 0 000-1.211zm5.527 4.423a1.711 1.711 0 100 3.422 1.711 1.711 0 000-3.422zm7.739 1.105a.606.606 0 100 1.211.606.606 0 000-1.21zM5.076 17.145a1.158 1.158 0 100 2.316 1.158 1.158 0 000-2.316zm13.266 1.105a1.158 1.158 0 100 2.317 1.158 1.158 0 000-2.317z","fill":"#FAD740"}})])
          )
        }
      }
    